import type { Resource } from '../../';
export const general_errors_unexpectedError: Resource = {"default":"An unexpected error occurred. Please try again later."};
